export const getPersonalizationSiteUserTraitsUrl: (userId: string) => string = (userId: string) =>
	`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`;
